import { Geometry } from 'geojson';

import { findPolylabel } from '../common';

const getCenterOfStateCountyGeometry = (geometry: Geometry | undefined) => {
  if (geometry) {
    const center = findPolylabel({
      geometry,
      properties: {},
      type: 'Feature',
    });

    return {
      center: {
        lat: center[1],
        lng: center[0],
      },
      geometry,
    };
  }

  return {
    center: {
      lat: 39,
      lng: -96,
      zoom: 3.5,
    },
  };
};

export default getCenterOfStateCountyGeometry;
